export default "__VITE_ASSET__2nSsIH3a__"